<script>
export default {
    name: 'oc-col',
    functional: true,
    props: {
        size: {
            type: [String, Number],
            validator: function (value) {
                return value === undefined || (parseInt(value) >= 1 && parseInt(value) <= 12)
            }
        }
    },
    render: function (h, context) {
        let data = Object.assign({}, context.data, {
            on: context.listeners
        })

        // calculate classes
        if( data.class === undefined ) {
            data.class = {}
        }
        if( ! isArray(data.class) ) {
            data.class = [data.class]
        }

        data.class = Vue.filter('mergeClassExpression')(
            data.class,
            [
                context.props.size ? 'col-md-' + context.props.size : 'col'
            ]
        )
        //

        return h(
            'div',
            data,
            context.slots().default
        )
    }
}
</script>
